<template>
  <div class="access-log-container">
    <!-- 搜索区域 -->
    <div class="search-area">
      <el-input
          v-model="searchKeyword"
          placeholder="请输入IP或所属地进行搜索"
          clearable
          style="width: 300px; margin-right: 10px;"
          @keyup.enter="searchLogs"
      />
      <el-button type="primary" @click="searchLogs" :loading="loading">
        搜索
      </el-button>
    </div>

    <!-- 表格展示区域 -->
    <el-table
        :data="tableData"
        v-loading="loading"
        class="access-table"
        style="width: 100%"
        border
        stripe
        height="calc(100vh - 230px)"
    >
      <el-table-column v-if="false" label="ID" prop="id" width="100" align="center"/>
      <el-table-column label="编号" prop="index" width="90" align="center"/>

      <el-table-column label="IP" prop="ip" width="150" align="center"/>

      <el-table-column label="所属地" prop="location" width="180" align="center"/>

      <el-table-column label="访问页面" prop="page" align="center"/>

      <el-table-column label="来源页面" prop="referrer" align="center" show-overflow-tooltip/>

      <el-table-column label="设备信息" prop="userAgent" align="center" show-overflow-tooltip/>

      <el-table-column label="停留时间(秒)" prop="duration" width="120" align="center">
        <template #default="scope">
          {{ formatDuration(scope.row.duration) }}
        </template>
      </el-table-column>

      <el-table-column label="访问时间" prop="accessTime" width="180" align="center">
        <template #default="scope">
          {{ formatTime(scope.row.accessTime) }}
        </template>
      </el-table-column>>
    </el-table>

    <!-- 分页组件 -->
    <div class="pagination-container">
      <el-pagination
          v-model:current-page="currentPage"
          :page-size="pageSize"
          :total="total"
          :pager-count="5"
          layout="prev, pager, next"
          @current-change="handlePageChange"
      />
    </div>

  </div>
</template>

<script setup>
import {ref, onMounted, watch} from 'vue'
import request from '@/utils/request'
import {ElMessage} from 'element-plus'

// 响应式数据
const searchKeyword = ref('')
const tableData = ref([])
const loading = ref(false)

// 防抖相关变量
const searchTimeout = ref(null)

// 分页变量
const currentPage = ref(1)
const pageSize = ref(15)
const total = ref(0)

// 搜索日志
const searchLogs = async () => {
  loading.value = true
  try {
    const response = await request.get('/log/access-search', {
      params: {
        keyword: searchKeyword.value,
        page: currentPage.value,
        size: pageSize.value
      }
    })

    console.log('完整响应:', response)
    console.log('响应数据:', response.data)

    if (response.code === '200') {
      const result = response.data
      console.log('列表数据:', result.list)
      console.log('列表长度:', result.list ? result.list.length : 0)

      if (result.list && result.list.length > 0) {
        // 处理返回的数据，为每条记录添加排序编号
        tableData.value = result.list.map((item, index) => {
          // 计算当前页面的序号
          const pageIndex = (currentPage.value - 1) * pageSize.value + index + 1
          return {
            index: pageIndex,
            id: item.id || '',
            ip: item.ip || '',
            location: item.location || '',
            page: item.page || '',
            referrer: item.referrer || '',
            userAgent: item.userAgent || '',
            duration: item.duration || 0,
            accessTime: item.accessTime || ''
          }
        })

        total.value = result.total || 0
        console.log('表格数据:', tableData.value)
        console.log('总记录数:', total.value)
      } else {
        tableData.value = []
        total.value = 0
        console.log('没有数据')
      }
    } else {
      console.error('接口返回错误码:', response.code, '消息:', response.msg)
      ElMessage.error('搜索失败: ' + (response.msg || '未知错误'))
    }
  } catch (error) {
    console.error('搜索日志失败:', error)
    if (error.response) {
      console.error('错误响应:', error.response.data)
    }
    ElMessage.error('搜索失败: ' + (error.message || '网络错误'))
  } finally {
    loading.value = false
  }
}

// 格式化停留时间（毫秒转秒）
const formatDuration = (duration) => {
  if (!duration && duration !== 0) return '0'
  // 如果已经是秒，直接返回
  if (duration < 1000) {
    return Math.round(duration)
  }
  // 如果是毫秒，转换为秒并保留2位小数
  return (duration / 1000).toFixed(2)
}

// 格式化时间 - 统一格式 YYYY-MM-DD
const formatTime = (time) => {
  if (!time) return '-'
  const date = new Date(time)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

// 监听搜索关键词变化
watch(searchKeyword, (newVal, oldVal) => {
  // 只有当从有值变为空时才自动搜索
  if (newVal === '' && oldVal !== '') {
    // 清除之前的定时器
    if (searchTimeout.value) {
      clearTimeout(searchTimeout.value)
    }

    // 重置页码到第一页
    currentPage.value = 1

    // 设置防抖，延迟300毫秒后搜索
    searchTimeout.value = setTimeout(() => {
      searchLogs()
    }, 300)
  }
})

// 处理页码变化
const handlePageChange = (page) => {
  currentPage.value = page
  searchLogs()
}

// 组件挂载时自动搜索
onMounted(() => {
  console.log('组件挂载完成，开始初始搜索')
  searchLogs()
})
</script>

<style scoped>
.access-log-container {
  padding: 20px;
  margin: 0 auto;
}

.search-area {
  margin-bottom: 20px;
  border-radius: 4px;
}


/* 表格样式 */
.access-table {
  margin-top: 20px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
}

:deep(.el-table__header) {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

:deep(.el-table__header th) {
  font-weight: 600;
  color: #1f2937;
  background-color: #f8fafc !important;
  font-size: 14px;
  letter-spacing: 0.025em;
}

:deep(.el-table__header .cell) {
  font-weight: 600;
  color: #374151;
}

/* 增强表格整体专业感 */
:deep(.el-table) {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

:deep(.el-table th),
:deep(.el-table td) {
  text-align: center;
  border-bottom: 1px solid #f3f4f6;
}

:deep(.el-table .el-table__row:hover > td) {
  background-color: #f9fafb;
}

/* 分页样式 */
.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
}

:deep(.el-pagination) {
  font-weight: normal;
}
</style>